import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, InputBase, Link} from '@material-ui/core';
import ProductCard from 'Components/order/ProductCard';
import Header from 'Components/lto/common/Header';
import {T} from 'Actions/translate';
import {
    addCart,
    getCartCount,
    updateOtherShipToNumber,
    updateProductSearchFields,
    getQuote,
    getCustomerQuote,
    operationLog,
    updateProducts,
    queryEoneInventory,
    batchAddCart,
    getTfsOfSkuInfor,
} from 'Actions/order';
import {getShipToOfScInfor} from 'Actions/noScOrder';
import {Search, PlaceOutlined} from '@material-ui/icons';
import BasicButton from 'Components/common/BasicButton';
import Anchor from 'Components/common/Anchor';
import Counter from 'Components/counter/Counter';
import Input from 'Components/common/Input';
import ScrollWrapper from '../common/ScrollWrapper';
import LoadingIcon from 'Components/icons/LoadingIcon';
import util from 'Utils/commonUtil';
import Dialog from 'Components/common/Dialog';

import {setUserData} from 'Actions/localData';
import {unBindGigya} from 'Actions/bind';
import {openNotification} from 'Actions/notification';
import {getCmgtOfSkuInfor} from 'Actions/noScOrder';
import {ExpandLess, ExpandMore} from '@material-ui/icons';
import logo from 'Images/logo_bottom.png';
import {
    NO_SUPPLY_CENTER_ID,
    USER_ROLE,
    PURCHASE_ORDER_MODE,
    PURCHASE_ORDER,
} from 'Utils/constant';

class DemoSiteOrderList extends Component {
    state = {
        searchKey: '',
        supplyCenterOpen: false,
        categroyOpen: false,
        shipToOpen: false,
        supplyCenterSort: 'asc',
        categroySort: 'asc',
        shipToSelected: '',
        shiToDialogOpened: false,
        chosed: false,
        displayTMProduct: false,
        pageLoad: false,
        isDemoSite: true,
        locationHidden: false,
        warningOpen: false,
        unBindDialogOpen: false,
        exitOpened: false,
        currentShippingAddress: '',
        isShowAddress: true,
        selectedShipToClassName: '',
        isQuoteInfor: false,
        cmgtInventoryList: [],
        addPageType: null,
        isProxyProcessType: null,
        hiddenAddBatchSkuArea: true,
        hiddenAddBatchSkuUpArea: false,
        displayQuicklyAddSkuBtn: true,
        batchSkuModalComps: [
            {
                modalId: 1,
                sku: '',
                quantity: 1,
                customerEmail:
                    this.props.location.state &&
                    this.props.location.state.customerEmail,
                productId: null,
                islegalFlag: false,
            },
            {
                modalId: 2,
                sku: '',
                quantity: 1,
                customerEmail:
                    this.props.location.state &&
                    this.props.location.state.customerEmail,
                productId: null,
                islegalFlag: false,
            },
            {
                modalId: 3,
                sku: '',
                quantity: 1,
                customerEmail:
                    this.props.location.state &&
                    this.props.location.state.customerEmail,
                productId: null,
                islegalFlag: false,
            },
        ],
        skuNum: 3,
        quicklyAddSkuCount: 0,
        tfsProductList: [],
        pageLoading: false,
        firstEnterDemoSiteOrderPage: true,
        onlineOrderDialogOpened: false,
        timer: PURCHASE_ORDER.TIMER,
    };

    searchRequestTimer = null;

    /**
		With Gigya Init Page
	*/

    componentWillMount() {
        this.props.getCartCount(this.getCustomerEmail());

        this.props.updateProductSearchFields('');

        if (
            util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.ONLINE ||
            util.getPurchaseOrderMode() === PURCHASE_ORDER_MODE.OFFLINE
        ) {
            console.log(
                '===================this.getFromSelectCustomerPage()',
                this.getFromSelectCustomerPage(),
            );
            console.log(
                '===================!this.props.fromShoppingCart',
                !this.props.fromShoppingCart,
            );
            if (
                this.getFromSelectCustomerPage() &&
                !this.props.fromShoppingCart
            ) {
                this.setState(
                    {
                        onlineOrderDialogOpened: true,
                    },
                    () => {
                        this.timeHandle();
                    },
                );
            }
        }
    }

    getFromSelectCustomerPage = () => {
        let fromSelectCustomerPage = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            fromSelectCustomerPage = routerState.fromSelectCustomerPage;
        }
        return fromSelectCustomerPage;
    };

    timeHandle = () => {
        window.clearInterval(this.intervalTimer);
        this.intervalTimer = setInterval(() => {
            if (this.state.timer === 0) {
                this.setState({
                    onlineOrderDialogOpened: false,
                });
            } else {
                this.setState({timer: this.state.timer - 1});
            }
        }, 1000);
    };

    openOnlineOrderDialog = () => {
        this.setState({
            timer: PURCHASE_ORDER.TIMER,
            onlineOrderDialogOpened: true,
        });
    };

    getShipToNumber = () => {
        let stNumber = '';
        if (
            this.props.location.state &&
            this.props.location.state.shipToNumber
        ) {
            stNumber = this.props.location.state.shipToNumber;
        }
        return stNumber;
    };

    getCustomerEmail = () => {
        let customerEmail = '';
        if (
            this.props.location.state &&
            this.props.location.state.customerEmail
        ) {
            customerEmail = this.props.location.state.customerEmail;
        }
        return customerEmail;
    };

    goToStApplyChange = () => {
        let stNumber = this.getShipToNumber();
        let item = {};

        this.props
            .getShipToOfScInfor(stNumber)
            .then((res) => {
                if (res && res.status === 'success') {
                    if (typeof res.data !== '{}') {
                        item = res.data;
                        this.props.history.push(`/stApplyChange`, {
                            stItem: item,
                            queryKey: this.props.queryKey,
                            noScOrderFlag: true,
                            currentEmail: this.getCustomerEmail(),
                        });
                    }
                }
            })
            .catch((res) => {
                if (res && res.status === 'Invalid_Ship_To') {
                    this.props.openNotification(T('invalid_shipTo'), 'danger');
                }
            });
    };

    // Display Thermofisher Product
    displayTMProduct = (value) => {
        this.setState({
            displayTMProduct: true,
            pageLoad: true,
        });

        let currentShipToNumber = this.getShipToNumber();

        let searchParm = value
            ? value.trim()
            : this.props.searchValue
            ? this.props.searchValue.trim()
            : this.props.searchValue;
        let searchParmKey = encodeURIComponent(searchParm);

        if (searchParm && searchParm.length >= 3) {
            this.props
                .getTfsOfSkuInfor(
                    searchParmKey,
                    currentShipToNumber,
                    this.hideloading,
                )
                .then((res) => {
                    if (
                        res.status === 'success' &&
                        res.data &&
                        res.data.length > 0
                    ) {
                        if (this.props.searchValue.trim()) {
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'class',
                                    'search_result_has_content',
                                );
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'testid',
                                    'search-result-sku-content',
                                );
                        }
                        let skuArr = [];
                        res.data.map((item) => {
                            if (item.type === 2) {
                                skuArr.push(item.sku);
                            }

                            return null;
                        });
                        this.queryCMGTInventory(skuArr, res.data);
                        this.getQuote(res.data.map((item) => item.sku));
                        this.setState({
                            tfsProductList: res,
                            addPageType: 'Thermofisher Searches',
                            isProxyProcessType: null,
                        });
                    } else {
                        if (this.props.searchValue.trim()) {
                            this.setState({
                                firstEnterDemoSiteOrderPage: false,
                                tfsProductList: res,
                            });
                            document
                                .getElementsByClassName('search-input')[0]
                                .getElementsByTagName('input')[0]
                                .setAttribute(
                                    'class',
                                    'search_result_no_content',
                                );
                        }
                    }
                })
                .catch((err) => {
                    this.hideloading();
                    this.setState({
                        firstEnterDemoSiteOrderPage: false,
                    });
                });
        } else {
            this.hideloading();
            this.props.openNotification(
                T('order_tm_query_Key_error'),
                'success',
                {
                    testid: 'product-search-keyword-validation',
                },
            );
        }
    };

    queryCMGTInventory = (params, tfsProductList) => {
        this.props.queryEoneInventory({skuList: params}).then((res) => {
            if (res) {
                let arr = tfsProductList.concat();
                arr.map((obj) => {
                    res.data.map((item) => {
                        if (item.sku === obj.sku) {
                            obj.availableInventory = parseInt(
                                item.availableInventory,
                            );
                        }

                        return null;
                    });

                    return null;
                });

                this.setState({
                    cmgtInventoryList: arr,
                });
            }
        });
    };

    hideloading = () => {
        //update SCME-1357
        if (this.props.localData.defaultScId !== 0 && this.state.isDemoSite) {
            this.setState({
                isDemoSite: false,
            });
        }
        this.setState({
            pageLoad: false,
        });
    };

    // TM Key Down Event Handling
    keyDownTM = (event) => {
        if (event.keyCode === 13) {
            this.handleSearchTM(event);
            event.currentTarget.blur();
            this.displayTMProduct(event.target.value);
        }
    };

    // TM Handle Serach
    handleSearchTM = (event) => {
        this.props.updateProductSearchFields(event.target.value);
    };

    searchTFSHandle = (searchValue) => {
        this.props.updateProductSearchFields(searchValue);
        this.displayTMProduct(searchValue);
    };

    goBack = () => this.props.history.goBack();

    quicklyAddProductHandle = () => {
        const {hiddenAddBatchSkuArea, batchSkuModalComps} = this.state;
        if (hiddenAddBatchSkuArea) {
            this.setState({
                hiddenAddBatchSkuUpArea: true,
                hiddenAddBatchSkuArea: false,
                displayQuicklyAddSkuBtn: false,
                batchSkuModalComps: batchSkuModalComps,
            });
        } else {
            this.setState({
                hiddenAddBatchSkuUpArea: false,
                hiddenAddBatchSkuArea: true,
                displayQuicklyAddSkuBtn: true,
            });
        }
    };

    hiddenBatchAddSkuHandle = () => {
        const {hiddenAddBatchSkuUpArea, batchSkuModalComps} = this.state;
        if (!hiddenAddBatchSkuUpArea) {
            this.setState({
                hiddenAddBatchSkuArea: false,
                hiddenAddBatchSkuUpArea: true,
                displayQuicklyAddSkuBtn: false,
            });
        } else {
            let currentSkuModalComps = JSON.parse(
                JSON.stringify(batchSkuModalComps),
            );
            let currentSkuCount = 0;
            currentSkuModalComps.forEach((skuModal, skuIndex) => {
                if (skuModal.sku) {
                    currentSkuCount++;
                }
            });

            this.setState({
                hiddenAddBatchSkuArea: true,
                hiddenAddBatchSkuUpArea: false,
                displayQuicklyAddSkuBtn: true,
                quicklyAddSkuCount: currentSkuCount,
                batchSkuModalComps: batchSkuModalComps,
            });
        }
    };

    addBatchAddSkuModal = () => {
        let {batchSkuModalComps, skuNum} = this.state;

        batchSkuModalComps.push({
            modalId: skuNum + 1,
            sku: '',
            quantity: 1,
            customerEmail: util.getPurchaseCustomerEmail(),
            productId: null,
            islegalFlag: false,
        });
        this.setState({
            batchSkuModalComps: batchSkuModalComps,
            skuNum: ++skuNum,
        });
    };

    deletBackupSkuModal = (comps) => {
        let {batchSkuModalComps} = this.state;
        if (batchSkuModalComps.length > 3) {
            batchSkuModalComps.splice(
                batchSkuModalComps.findIndex((item) => item.modalId === comps),
                1,
            );
            this.setState({
                batchSkuModalComps: batchSkuModalComps,
            });
        } else {
            this.props.openNotification(
                T('quickly_batch_add_product_need_three_sku'),
            );
        }
    };

    addBatchShoppingCartHandle = (event) => {
        let {batchSkuModalComps} = this.state;
        let batchAddSkuParams = this.getBatchSkuModal();

        let currentBatchSkuModalComps = JSON.parse(
            JSON.stringify(this.state.batchSkuModalComps),
        );
        if (batchAddSkuParams.length > 0) {
            this.setState({
                pageLoading: true,
            });
            this.props
                .batchAddCart(batchAddSkuParams)
                .then((res) => {
                    let params = this.getBatchAddSkuAnimationParams(event);
                    util.addShoppingCartAnimation(params);

                    let intitSkuModal = [];
                    batchSkuModalComps.forEach((skuModal, skuModalIndex) => {
                        if (skuModalIndex <= 2) {
                            let currentSkuModal = {
                                modalId: skuModalIndex + 1,
                                sku: '',
                                quantity: 1,
                                customerEmail:
                                    this.props.location.state &&
                                    this.props.location.state.customerEmail,
                                productId: null,
                                islegalFlag: false,
                            };
                            intitSkuModal.push(currentSkuModal);
                        }
                    });
                    this.setState({
                        batchSkuModalComps: intitSkuModal,
                        quicklyAddSkuCount: 0,
                        pageLoading: false,
                    });
                })
                .catch((res) => {
                    // if (res.status === 'no_content') {
                    //     this.props.openNotification(T('quickly_add_sku_no_sku', [res.message]));
                    //     this.blurSkuQueryChange(0);
                    // }
                    // else if (res.status === 'invalid_sku_price') {
                    //     this.props.openNotification(T('tfs_sku_not_pricr_not_sales', [res.message]));
                    // }

                    let currentBatchSkuModalComps = JSON.parse(
                        JSON.stringify(this.state.batchSkuModalComps),
                    );
                    if (
                        res.status === 'invalid_erpType' &&
                        this.getSKUList(currentBatchSkuModalComps).length > 0
                    ) {
                        this.props.openNotification(
                            T('quickly_add_sku_is_fsbio'),
                        );
                    }
                    this.clearQuicklyAddSkuModal(currentBatchSkuModalComps);

                    currentBatchSkuModalComps.forEach(
                        (catchSkuModal, catchSkuIndex) => {
                            if (res.message === catchSkuModal.sku) {
                                catchSkuModal.sku = '';
                                catchSkuModal.quantity = 1;
                                catchSkuModal.islegalFlag = false;
                            }
                        },
                    );
                    this.setState({
                        batchSkuModalComps: currentBatchSkuModalComps,
                        pageLoading: false,
                    });
                });
        } else {
            this.props.openNotification(
                T('enter_information_at_least_one_sku'),
            );
        }
    };

    getSKUList = (currentBatchSkuModalComps) => {
        let skuList = [];
        currentBatchSkuModalComps.forEach((skuModal, skuIndex) => {
            if (skuModal.sku && skuModal.sku.trim()) {
                skuList.push(skuModal.sku.trim());
            }
        });
        return skuList;
    };

    getBatchAddSkuAnimationParams = (event) => {
        const shoppingCartBtn = document.getElementById('shippingcart-btn');
        const animationTime = 600;

        let isPhoneFlag = false;
        if (
            util.isPhone() &&
            event.touches !== 'undefined' &&
            event.touches &&
            event.touches.length > 0
        ) {
            isPhoneFlag = true;
        }
        const clientX = isPhoneFlag ? event.touches[0].clientX : event.clientX;
        const clientY = isPhoneFlag ? event.touches[0].clientY : event.clientY;
        let params = {
            shoppingCartBtn: shoppingCartBtn,
            productInfo: null,
            event: event,
            animationTime: animationTime,
            clientX: clientX,
            clientY: clientY,
        };

        return params;
    };

    getBatchSkuModal = () => {
        let batchAddSkuParams = [];
        let currentBatchSkuModalComps = JSON.parse(
            JSON.stringify(this.state.batchSkuModalComps),
        );
        currentBatchSkuModalComps.forEach((skuModal, skuIndex) => {
            if (skuModal.sku && skuModal.sku.trim()) {
                batchAddSkuParams.push(skuModal);
            }
        });
        return batchAddSkuParams;
    };

    inputSkuQueryChange = (title, value) => {
        let number = parseInt(title.slice(3));

        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.batchSkuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (number === skuModal.modalId) {
                skuModal.sku = value;
            }
        });

        this.setState({
            [title]: value,
            batchSkuModalComps: currentSkuModalComps,
        });
    };

    quantityChange = (value, currentIndex) => {
        let currentSkuModalComps = JSON.parse(
            JSON.stringify(this.state.batchSkuModalComps),
        );
        currentSkuModalComps.forEach((skuModal, skuIndex) => {
            if (currentIndex === skuModal.modalId) {
                skuModal.quantity = value ? parseInt(value) : 1;
            }
        });
        this.setState({
            batchSkuModalComps: currentSkuModalComps,
        });
    };

    blurSkuQueryChange = (currentSkuIndex, skuNum) => {
        let currentBatchSkuModalComps = JSON.parse(
            JSON.stringify(this.state.batchSkuModalComps),
        );
        let currentSku = 0;
        currentBatchSkuModalComps.forEach((skuModal, skuIndex) => {
            if (currentSkuIndex === skuModal.modalId) {
                currentSku = skuModal.sku;
            }
        });

        if (currentSku !== 0 && currentSku.trim()) {
            this.props
                .getCmgtOfSkuInfor(currentSku.trim(), this.getShipToNumber())
                .then((res) => {
                    if (res.status === 'success') {
                        if (res.data) {
                            currentBatchSkuModalComps.forEach(
                                (successSkuModal, successSkuIndex) => {
                                    if (
                                        currentSkuIndex ===
                                        successSkuModal.modalId
                                    ) {
                                        successSkuModal.islegalFlag = true;
                                        if (
                                            successSkuModal.sku !== res.data.sku
                                        ) {
                                            successSkuModal.sku = res.data.sku;
                                        }
                                    }
                                },
                            );
                            this.setState({
                                batchSkuModalComps: currentBatchSkuModalComps,
                            });
                        }
                    }
                })
                .catch((res) => {
                    if (res.data) {
                        if (res.status === 'invalid_sku_price') {
                            this.props.openNotification(
                                T('tfs_sku_not_pricr_not_sales', [skuNum]),
                            );
                        } else if (res && res.status === 'no_sku_permission') {
                            let devisionValue =
                                util.getNoPermissionSkuDevision(res);

                            this.props.openNotification(
                                T('other_division_no_perssion', [
                                    devisionValue,
                                ]),
                            );
                        }
                    } else {
                        if (res.status === 'no_content') {
                            this.props.openNotification(
                                T('quickly_add_sku_no_sku', [skuNum]),
                            );
                        } else if (res.status === 'invalid_erpType') {
                            this.props.openNotification(
                                T('quickly_add_sku_is_fsbio'),
                            );
                        }
                    }
                    this.clearQuicklyAddSkuModal(
                        currentBatchSkuModalComps,
                        currentSkuIndex,
                    );
                });
        }
    };

    clearQuicklyAddSkuModal = (currentBatchSkuModalComps, currentSkuIndex) => {
        currentBatchSkuModalComps.forEach((catchSkuModal, catchSkuIndex) => {
            if (currentSkuIndex === catchSkuModal.modalId) {
                catchSkuModal.sku = '';
                catchSkuModal.quantity = 1;
                catchSkuModal.islegalFlag = false;
            }
        });
        this.setState({
            batchSkuModalComps: currentBatchSkuModalComps,
        });
    };
    // Go To Shopping Cart Page
    goToShoppingCart = () => {
        this.props.setUserData({
            data: {
                email: this.getCustomerEmail(),
                shipToNum: this.getShipToNumber(),
                isProxyProcess: true,
                type: this.props.localData.roleType,
                name: this.props.localData.name,
            },
        });

        this.props.history.push('/purchase/shoppingCart', {
            batchAddEmail: this.getCustomerEmail(),
            batchAddShipTo: this.getShipToNumber(),
            customerEmail: util.getPurchaseCustomerEmail(),
            customerName: util.getPurchaseCustomerName(),
        });
    };

    // Add Shopping Cart Button event Handling
    addShoppingCart = (productInfo, num, event) => {
        const {localData} = this.props;
        const animationTime = 600;

        let isPhoneFlag = false;
        if (
            util.isPhone() &&
            event.touches !== 'undefined' &&
            event.touches &&
            event.touches.length > 0
        ) {
            isPhoneFlag = true;
        }
        const clientX = isPhoneFlag ? event.touches[0].clientX : event.clientX;
        const clientY = isPhoneFlag ? event.touches[0].clientY : event.clientY;

        this.props.operationLog({
            opTarget: 'add_sku_to_cart',
            opContent: productInfo.sku,
            opReqUrl: '/api/cart/add',
        });
        this.props
            .addCart({
                productId: productInfo.id,
                customerEmail: util.getPurchaseCustomerEmail()
                    ? util.getPurchaseCustomerEmail()
                    : localData.customerEmail,
                quantity: num,
                sku: productInfo.sku,
            })
            .then(() => {
                const shoppingCartBtn =
                    document.getElementById('shippingcart-btn');
                if (productInfo && num) {
                    let pageType;
                    if (
                        this.props.history.location.state &&
                        this.state.addPageType == null &&
                        (this.props.history.location.state.type ==
                            'Search Results' ||
                            this.props.history.location.state.type ==
                                'Recent Searches' ||
                            this.props.history.location.state.type ==
                                'Hot Searches')
                    ) {
                        pageType = this.props.history.location.state.type;
                    } else if (
                        this.state.addPageType !== null &&
                        this.state.addPageType == 'Thermofisher Searches'
                    ) {
                        pageType = 'Thermofisher Searches';
                    } else {
                        pageType = 'Home Page';
                    }

                    if (this.state.isProxyProcessType) {
                        pageType = this.state.isProxyProcessType;
                    }
                }
                let params = {
                    shoppingCartBtn: shoppingCartBtn,
                    productInfo: productInfo,
                    event: event,
                    animationTime: animationTime,
                    clientX: clientX,
                    clientY: clientY,
                };
                util.addShoppingCartAnimation(params);
            });
    };

    getQuote = (param) => {
        let currentData = {};
        if (this.getCustomerEmail()) {
            currentData.customerEmail = this.getCustomerEmail();
            currentData.scId = NO_SUPPLY_CENTER_ID;
            this.props.getCustomerQuote(param, currentData);
        } else {
            this.props.getCustomerQuote(
                param,
                this.props.localData,
                // this.quoteCallback,
            );
        }
    };

    quoteCallback = (res) => {
        console.log('quoteCallback', res);
        if (res.status === 'success' && res.data.length !== 0) {
            this.setState({
                isQuoteInfor: true,
            });
        } else if (res.status === 'success' && res.data.length === 0) {
            this.props.openNotification(
                T('notification_quote_null'),
                'success',
            );
        } else {
            this.props.openNotification(
                T('notification_get_quote_failed'),
                'success',
            );
        }
    };

    getPurchaseCustomerName = () => {
        let customerName = '';
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerName = routerState.customerName;
        }
        return customerName;
    };

    getPurchaseCustomerEmail = () => {
        let customerEmail = undefined;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            customerEmail = routerState.customerEmail;
        }
        return customerEmail;
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
            });
        }
    };

    render() {
        const {
            pageLoad,
            addPageType,
            isProxyProcessType,
            isQuoteInfor,
            hiddenAddBatchSkuArea,
            hiddenAddBatchSkuUpArea,
            displayQuicklyAddSkuBtn,
            batchSkuModalComps,
            quicklyAddSkuCount,
            tfsProductList,
            pageLoading,
            firstEnterDemoSiteOrderPage,
            onlineOrderDialogOpened,
            timer,
        } = this.state;
        const {
            quoteCustomerInfor,
            tmProductList,
            searchValue,
            cartCount,
            localData,
        } = this.props;
        let currentProductType = '';

        return (
            <div className="demo-site-order-list lto-demo-site-order-list">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                {pageLoading ? (
                    <div className="checkout-loading-mask">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : null}
                <Header
                    hasBatchAddShoppingCart={true}
                    hasUserCenter={true}
                    backEvent={this.goBack}
                    shoppingCartEvent={this.goToShoppingCart}
                    batchAddcartCount={cartCount}
                    batchAddSkuEmail={this.getCustomerEmail()}
                    hasArrowBackIos={true}
                    isNoSupplyCenter={true}
                    showTipIcon={true}
                    openOnlineOrderDialog={this.openOnlineOrderDialog}
                    ltoPageTitle={
                        util.getPurchaseOrderMode() ===
                        PURCHASE_ORDER_MODE.ONLINE
                            ? T('lto_purchase_order_line_up')
                            : T('lto_purchase_order_line_down')
                    }
                    batchAddSkuShipTo={this.getShipToNumber()}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-header-content" item xs={11}>
                            {util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.ONLINE && (
                                <Grid
                                    className="customer-email-content"
                                    item
                                    xs={12}>
                                    <img
                                        src={
                                            new URL(
                                                'Images/customer_icon.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                    <label className="text-ellipsis">
                                        {util.getPurchaseCustomerName()}
                                    </label>
                                    <label className="text-ellipsis">
                                        {util.getPurchaseCustomerEmail()}
                                    </label>
                                </Grid>
                            )}

                            <Grid className="shipto-and-sc" item xs={12}>
                                <Grid
                                    className="left-content"
                                    item
                                    xs={12}
                                    testid="no_supply_center_header_ship-to_number">
                                    <img
                                        src={
                                            new URL(
                                                'Images/ST.svg',
                                                import.meta.url,
                                            ).href
                                        }
                                        alt=""
                                    />
                                    {this.getShipToNumber()}
                                </Grid>
                                {/* <Grid
                                    className="supply-center-title text-ellipsis"
                                    item
                                    xs={8}>
                                    <PlaceOutlined />
                                    <span className="text-ellipsis">
                                        {localData.scName}
                                    </span>
                                </Grid> */}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid
                        className="page-search-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-search" item xs={11}>
                            <div className="search-icon">
                                <Search />
                            </div>
                            <form className="search-form">
                                <InputBase
                                    placeholder={T('enterProductName')}
                                    className="search-input"
                                    inputProps={{
                                        'data-testid': 'product-search-input',
                                    }}
                                    type={'search'}
                                    onKeyDown={this.keyDownTM}
                                    onChange={this.handleSearchTM}
                                    value={searchValue}
                                />
                                <Anchor
                                    className="search-link"
                                    testid="product-search-button"
                                    onClickOfSingleTap={(event) =>
                                        this.searchTFSHandle(searchValue)
                                    }>
                                    {'搜索'}
                                </Anchor>
                            </form>
                        </Grid>
                    </Grid>
                </Header>

                <ScrollWrapper
                    showLoadingMore={false}
                    showAbyss={false}
                    listLoaded={true}>
                    {tfsProductList.data &&
                    tfsProductList.data.length >
                        0 ? null : firstEnterDemoSiteOrderPage ? (
                        <Grid
                            className="no-thermofisher-product-container top-margin"
                            item
                            xs={12}>
                            <Grid item xs={12}>
                                <p
                                    className="no-thermofisher-product-hint"
                                    testid="no-thermofisher-product-hint">
                                    当前页面产品将由网站配送
                                </p>
                                {localData.roleType == USER_ROLE.SALES ? (
                                    <p className="no-thermofisher-product-hint">
                                        如果您附近有现货中心，请
                                        <label
                                            onClick={this.goToStApplyChange}
                                            className="go-to-st-apply-change">
                                            {T(
                                                'apply_associated_supply_center',
                                            )}
                                        </label>
                                    </p>
                                ) : null}
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid className="no-search-result-container">
                            <p className="first-area">
                                {T('no_search_sku_result')}
                            </p>
                            <p className="two-area">
                                {T('please_use_precision_search')}
                            </p>
                            <p className="two-area">
                                {T('please_use_quickly_add_sku_function')}
                            </p>
                            <p className="two-area">
                                {T('need_help_contact_us')}
                            </p>

                            <Grid
                                className="contact-us-row contact-business-row three-area"
                                item
                                xs={12}>
                                <span className="contact-us-label">
                                    {T('order_service_hot_line')}
                                </span>
                                <span className="contact-us-telephone">
                                    <Link c href={'tel://400 820 8982'}>
                                        {T('contact_telephone_one')}
                                    </Link>{' '}
                                    /{' '}
                                    <Link href={'tel://800 820 8982'}>
                                        {T('contact_telephone_two')}
                                    </Link>
                                </span>
                            </Grid>
                            <Grid
                                className="contact-us-row contact-business-row"
                                item
                                xs={12}>
                                <span className="contact-us-label">
                                    {T('order_business_consult')}
                                </span>
                                <span className="contact-us-email">
                                    {T('order_business_consult_email')}
                                </span>
                            </Grid>
                        </Grid>
                    )}
                    {pageLoad ? (
                        <LoadingIcon className="circle-animation" />
                    ) : (
                        <Grid
                            className="tm-product-card-list-container no-margin"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            {tfsProductList.data &&
                                tfsProductList.data.map((item, i) => {
                                    return (
                                        <Grid
                                            className="product-card-list"
                                            key={i}
                                            item
                                            xs={11}>
                                            <ProductCard
                                                productInfo={item}
                                                customerData={{
                                                    customerEmail:
                                                        this.getCustomerEmail(),
                                                    shipToNum:
                                                        this.getShipToNumber(),
                                                }}
                                                history={this.props.history}
                                                itemPosition={'homepage'}
                                                addShoppingCart={
                                                    this.addShoppingCart
                                                }
                                                isProduct={true}
                                                isDemoSite={false}
                                                quoteInfor={quoteCustomerInfor}
                                                isQuoteInfor={isQuoteInfor}
                                                closeQuoteDetails={
                                                    this.closeQuoteDetails
                                                }
                                                copyContent={this.copyContent}
                                                operation={this.viewSkuDetail}
                                                currentProductType={
                                                    currentProductType
                                                }
                                                isProxyProcessType={
                                                    isProxyProcessType
                                                }
                                                addPageType={addPageType}
                                                otherDivision={true}
                                            />
                                        </Grid>
                                    );
                                })}

                            {tfsProductList.data &&
                            tfsProductList.data.length > 0 ? (
                                <div className="abyss-sect">
                                    <div className="hr-sect">
                                        <span className="finish-line">
                                            {T('already_in_the_bottom')}
                                        </span>
                                    </div>
                                    <div className="image-sect">
                                        <img
                                            src={logo}
                                            className="logo"
                                            alt="tfc logo"
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </Grid>
                    )}
                </ScrollWrapper>

                <Dialog
                    contentStyle={{width: '100%'}}
                    dialogDidClose={() =>
                        this.closeDialog('onlineOrderDialogOpened')
                    }
                    opened={onlineOrderDialogOpened}
                    isBottomDialog={true}
                    options={{bgClickClose: false}}>
                    <div className="please-advised-dialog">
                        <Grid className="dialog-title" container spacing={0}>
                            <Grid item xs={12}>
                                <span>
                                    {T('lto_purchase_order_please_advised')}
                                </span>
                            </Grid>
                        </Grid>

                        <Grid
                            className="dialog-content"
                            container
                            spacing={0}
                            justify={'center'}>
                            <Grid item xs={10}>
                                {util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.ONLINE ? (
                                    <ul>
                                        <li>
                                            {T(
                                                'lto_purchase_order_please_advised_content1',
                                            )}
                                        </li>
                                        <li>
                                            {T(
                                                'lto_purchase_order_please_advised_content21',
                                            )}
                                            <strong>
                                                {T(
                                                    'lto_purchase_order_please_advised_content22',
                                                )}
                                            </strong>
                                            {T(
                                                'lto_purchase_order_please_advised_content23',
                                            )}
                                            <strong>
                                                {T(
                                                    'lto_purchase_order_please_advised_content24',
                                                )}
                                            </strong>
                                            {T(
                                                'lto_purchase_order_please_advised_content25',
                                            )}
                                        </li>
                                    </ul>
                                ) : (
                                    <div className="offline-reminder-container">
                                        <div className="offline-reminder-message1">
                                            {T('new_offline_reminder_message1')}
                                            <span className="offline-reminder-highlight">
                                                {T(
                                                    'new_offline_reminder_message1_part2',
                                                )}
                                            </span>
                                        </div>
                                        <div className="offline-reminder-message2">
                                            {T('new_offline_reminder_message2')}
                                        </div>
                                        <div className="offline-reminder-message3">
                                            {T('new_offline_reminder_message3')}
                                        </div>
                                    </div>
                                )}
                                {util.getPurchaseOrderMode() ===
                                PURCHASE_ORDER_MODE.ONLINE ? (
                                    <span className="online-reminder-last-message">
                                        {T(
                                            'lto_purchase_order_please_advised_content3',
                                        )}
                                    </span>
                                ) : null}
                            </Grid>
                        </Grid>

                        <Grid container spacing={0}>
                            <Grid item xs={12} align="center">
                                <BasicButton
                                    className="close-confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={() =>
                                        this.closeDialog(
                                            'onlineOrderDialogOpened',
                                        )
                                    }>
                                    <div>
                                        {T('lto_purchase_order_close_tip_info')}
                                        {/* <label className="close-timer">
                                            {T('lto_purchase_order_timer', [
                                                timer,
                                            ])}
                                        </label> */}
                                    </div>
                                </BasicButton>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog>

                <div className="demo-site-order-footer-wrap">
                    <div className="demo-site-list-footer container-max-width is-fixed">
                        <div className="add-sku-templetes">
                            {hiddenAddBatchSkuUpArea ? (
                                <div className="expand-more-templete-sku">
                                    <ExpandMore
                                        onClick={this.hiddenBatchAddSkuHandle}
                                    />
                                </div>
                            ) : null}
                            {!hiddenAddBatchSkuArea ? (
                                <div>
                                    <div className="multiple-sku-container">
                                        {batchSkuModalComps.map(
                                            (comps, index) => (
                                                <div
                                                    key={index + 1}
                                                    className="sku-container">
                                                    <div className="sku-rows">
                                                        <label className="required-label">
                                                            *
                                                        </label>
                                                        <label className="sku-label">
                                                            货号
                                                        </label>
                                                        <Input
                                                            className="input-sku-area"
                                                            title={
                                                                'sku' +
                                                                comps.modalId
                                                            }
                                                            placeholder="请输入货号"
                                                            value={comps.sku}
                                                            key={comps.modalId}
                                                            onChange={
                                                                this
                                                                    .inputSkuQueryChange
                                                            }
                                                            onBlur={() =>
                                                                this.blurSkuQueryChange(
                                                                    comps.modalId,
                                                                    comps.sku,
                                                                )
                                                            }
                                                        />
                                                        <Counter
                                                            defalutValue={
                                                                comps.quantity
                                                            }
                                                            currentSkuIndex={
                                                                comps.modalId
                                                            }
                                                            inputValid={
                                                                this
                                                                    .quantityChange
                                                            }
                                                            testid="batch-sku-counter"
                                                            options={{min: 1}}
                                                        />
                                                        <div className="delete-sku-label">
                                                            <Anchor
                                                                className="delete-backup-a"
                                                                onClickOfSingleTap={() =>
                                                                    this.deletBackupSkuModal(
                                                                        comps.modalId,
                                                                    )
                                                                }>
                                                                <span className="backup-delete-btn">
                                                                    {T(
                                                                        'demo_site_delete_sku_row_button',
                                                                    )}
                                                                </span>
                                                            </Anchor>
                                                        </div>
                                                    </div>
                                                </div>
                                            ),
                                        )}
                                    </div>
                                    <div className="add-sku-div">
                                        <BasicButton
                                            className="add-sku-area"
                                            onClickOfSingleTap={
                                                this.addBatchAddSkuModal
                                            }>
                                            <label className="plus-label">
                                                +
                                            </label>
                                            {T('demo_site_add_sku_button')}
                                        </BasicButton>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        {displayQuicklyAddSkuBtn ? (
                            <div className="quickly-add-product-container">
                                <BasicButton
                                    className="add-shopping-cart-area"
                                    testid="quickly-add-product-button"
                                    onClickOfSingleTap={
                                        this.quicklyAddProductHandle
                                    }>
                                    <ExpandLess testid="quickly-add-product-button-icon" />
                                    {T('quickly_add_product')}
                                    {quicklyAddSkuCount > 0 ? (
                                        <div
                                            className="red-quantity"
                                            testid="quickly-add-product-button-quantity">
                                            {quicklyAddSkuCount}
                                        </div>
                                    ) : null}
                                </BasicButton>
                            </div>
                        ) : null}
                        <BasicButton
                            className="demo-site-btn"
                            testid="tm-add-shopping-cart-button"
                            type="primary"
                            isMouseDownEvent={true}
                            onClickOfSingleTap={(event) =>
                                this.addBatchShoppingCartHandle(event)
                            }>
                            {T('demo_site_order_add_shopping_cart')}
                        </BasicButton>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {order, localData, activity, noScOrder} = state;
    return {
        shipTo: order.shipTo,
        supplyCenter: order.supplyCenter,
        searchProductList: order.searchProductList,
        productList: order.productList,
        listLoaded: order.productListLoaded,
        productLoadingMore: order.productLoadingMore,
        localData: localData,
        cartCount: order.cartCount,
        tmProductList: order.tmProductList,
        otherShipToNumber: order.otherShipToNumber,
        quoteInfor: order.quoteInfor.data,
        quoteCustomerInfor: order.quoteCustomerInfor.data,
        searchValue: order.searchValue,
        shipToInforOfApplyChange: noScOrder.shipToInforOfApplyChange,
        cmgtOfSkuInfor: noScOrder.cmgtOfSkuInfor,
        noScOrderResult: order.noScOrderResult,
        fromShoppingCart: order.fromShoppingCart,
    };
};

const mapDispatchToProps = {
    addCart,
    getCartCount,
    getTfsOfSkuInfor,
    setUserData,
    unBindGigya,
    openNotification,
    updateOtherShipToNumber,
    updateProductSearchFields,
    getQuote,
    getCustomerQuote,
    operationLog,
    updateProducts,
    queryEoneInventory,
    getShipToOfScInfor,
    batchAddCart,
    getCmgtOfSkuInfor,
};

export default connect(mapStateToProps, mapDispatchToProps)(DemoSiteOrderList);
